/* Page to fetch all Walkies data  */
import React, { useEffect, useState } from "react"
import Alert from "react-bootstrap/Alert"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"
import Container from "react-bootstrap/Container"

import appStyles from "../../App.module.css"
import styles from "../../styles/Callsheets.module.css"
import { axiosInstance, axiosReq } from "../../api/axiosDefaults"
import btnStyles from "../../styles/Button.module.css"
import { useHistory } from "react-router-dom"
import toast from "react-hot-toast"
import Asset from "../../components/Asset"
import { Button } from "react-bootstrap"
import TopBox from "../../components/TopBox"
import { useCurrentUser } from "../../contexts/CurrentUserContext"
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config"
import useHostName from "../../hooks/useHostName"
import ImportWalk2 from "./ImportWalk2"

const WalkiesPage2 = () => {
  const host = useHostName()
  const currentUser = useCurrentUser()
  const [walkies, setWalkies] = useState({})
  // eslint-disable-next-line
  const [error, setErrors] = useState({})
  const [hasLoaded, setHasLoaded] = useState(false)
  const history = useHistory()
  const [showImp, setShowImp] = useState(false);
  const { id } = walkies || {};
  const hasWalkies = Boolean(id);

  const fetchWalkies = async () => {
      try {
        if (host === CLIENT_PROGRAM_HOSTNAME) {
          const { data } = await axiosReq.get(`/masters/walkies/?is_second_unit=true`)
          setWalkies(data.results?.[0] || {})
          setHasLoaded(true)
        } else {
          const response = await axiosInstance.get(
            `${localStorage.getItem("projectSlug")}/masters/walkies/?is_second_unit=true`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
              },
              withCredentials: true,
            }
          )
          if (response?.success === false) {
            throw response.error;
          }
          const { data } = response;
          setWalkies(data.results?.[0] || {})
          setHasLoaded(true)
        }
      } catch (err) {
        console.log(err)
        const backendError =
          err?.response?.data?.error ||
          err?.response?.data?.detail ||
          "Failed to load Walkies.";
        toast.error(backendError)
        if (err.response?.status !== 401) {
          setErrors(err.response?.data || { detail: ["Failed to load Walkies."] })
          setHasLoaded(true)
        }
      }
    }

  useEffect(() => {
    setHasLoaded(false)
      fetchWalkies();
      // eslint-disable-next-line
    }, []);

  const {
    walkie_channel_production,
    walkie_channel_open,
    walkie_channel_transportation,
    walkie_channel_art_dept,
    walkie_channel_rollover,
    walkie_channel_camera,
    walkie_channel_electric,
    walkie_channel_grip,
  } = walkies;

  return (
    <div>
      <TopBox 
      second="2ND UNIT"
      title="Walkies" />
      <Row className="my-2">
      <Col xs={6} >
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} py-0`}
        onClick={() => history.goBack()}
      >
        Back
      </Button>
      </Col>
      <Col xs={6} >
      <Button
        className={`float-right py-0 px-2 px-md-3 ${btnStyles.Order} ${btnStyles.Button}`}
        onClick={() => setShowImp((showImp) => !showImp)}
      >
        INFO
      </Button>
      </Col>
      </Row>      
      <h3 className="text-center">WALKIES - 2ND UNIT</h3>
      <hr className={`mt-0 mb-0 py-1 ${styles.BreakTitle}`}/>
      {!showImp ? "" : <ImportWalk2 />}
      {error?.detail?.map((message, idx) => (
        <Alert variant="warning" key={idx} className="my-2">
          {message}
        </Alert>
      ))}
      {(id)
      ? (
          <Row className="mt-3">
        <Col className="text-center">
          {currentUser &&
            currentUser?.groups.length > 0 &&
            (currentUser?.groups[0]?.name === "Admin" ||
              currentUser?.groups[0]?.name === "Superadmin") && (
              <Button
                onClick={() =>
                  history.push(
                    `/${localStorage.getItem("projectSlug")}/walkies2ndunit/edit/${id}/`
                  )
                }
                className={`${btnStyles.Button} ${btnStyles.Wide2} ${btnStyles.Bright}`}
              >
                Edit Walkies
              </Button>
            )}
        </Col>
      </Row>
      ) : (
        <Row className="mt-3">
        <Col className="text-center">
          {currentUser &&
            currentUser?.groups.length > 0 &&
            (currentUser?.groups[0]?.name === "Admin" ||
              currentUser?.groups[0]?.name === "Superadmin") && (
              <Button
                onClick={() =>
                  history.push(
                    `/${localStorage.getItem("projectSlug")}/walkies2ndunit/create`
                  )
                }
                className={`${btnStyles.Button} ${btnStyles.Wide2} ${btnStyles.Bright}`}
              >
                Add Walkies
              </Button>
            )}
        </Col>
      </Row>
      )}
        {hasLoaded ? (
          <>
            {hasWalkies ? (
            <div className='mt-5 mb-5 mx-5'>
            <hr className={`mb-0 pb-0 pl-3 mt-0 pt-0 ${styles.Break5 }`}/> 
            <Row className='px-md-3'>
            <Col md={3} xs={6} className={`${styles.Border2}`}>
            <Row>
            <Col xs={9} lg={6} ><p className={`pt-1 ${styles.Walk1}`}>PRODUCTION:</p></Col>
            <Col xs={3} lg={6}><p className={` pt-1 ${styles.Walk2}`}>{walkie_channel_production}</p></Col>
            </Row>
            </Col>
            <Col md={3} xs={6} className={`${styles.Border2}`}>
            <Row>
            <Col xs={9} lg={6}><p className={`pt-1 ${styles.Walk1}`}>OPEN:</p></Col>
            <Col xs={3} lg={6}><p className={`pt-1 ${styles.Walk2}`}>{walkie_channel_open}</p></Col>
            </Row>
            </Col>
            <Col md={3} xs={6} className={`${styles.Border2}`}>
            <Row>
            <Col xs={9} lg={6}><p className={`pt-1 ${styles.Walk1}`}>ROLLOVER:</p></Col>
            <Col xs={3} lg={6}><p className={`pt-1 ${styles.Walk2}`}>{walkie_channel_rollover}</p></Col>
            </Row>
            </Col>
            <Col md={3} xs={6} className={`${styles.Border2}`}>
            <Row>
            <Col xs={9} lg={6}><p className={`pt-1 ${styles.Walk1}`}>TRANSPORT:</p></Col>
            <Col xs={3} lg={6}><p className={`pt-1 ${styles.Walk2}`}>{walkie_channel_transportation}</p></Col>
            </Row>
            </Col>
            <Col md={3} xs={6} className={`${styles.Border2}`}>
            <Row>
            <Col xs={9} lg={6}><p className={`pt-1 ${styles.Walk1}`}>ART DEPT:</p></Col>
            <Col xs={3} lg={6}><p className={`pt-1 ${styles.Walk2}`}>{walkie_channel_art_dept}</p></Col>
            </Row>
            </Col>
            <Col md={3} xs={6} className={`${styles.Border2}`}>
            <Row>
            <Col xs={9} lg={6}><p className={`pt-1 ${styles.Walk1}`}>CAMERA:</p></Col>
            <Col xs={3} lg={6}><p className={`pt-1 ${styles.Walk2}`}>{walkie_channel_camera}</p></Col>
            </Row>
            </Col>
            <Col md={3} xs={6} className={`${styles.Border2}`}>
            <Row>
            <Col xs={9} lg={6}><p className={`pt-1 ${styles.Walk1}`}>ELECTRIC:</p></Col>
            <Col xs={3} lg={6}><p className={`pt-1 ${styles.Walk2}`}>{walkie_channel_electric}</p></Col>
            </Row>
            </Col>
            <Col md={3} xs={6} className={`${styles.Border2}`}>
            <Row>
            <Col xs={9} lg={6}><p className={`pt-1 ${styles.Walk1}`}>GRIP:</p></Col>
            <Col xs={3} lg={6}><p className={`pt-1 ${styles.Walk2}`}>{walkie_channel_grip}</p></Col>
            </Row>
            </Col>
            </Row>
            <hr className={`mb-0 pl-3 mt-0 pt-1 ${styles.Break5 }`}/>
            </div>
            ) : null}
          </>
        ) : (
          <Container className={appStyles.Content}>
            <Asset spinner />
          </Container>
        )}
    </div>
  )
}

export default WalkiesPage2
